import { useEffect, useState } from "react";
export interface FirebaseMessage {
  notification?: {
    title?: string;
    body?: string;
    image?: string;
  };
  data?: Record<string, string>;
}
export function useFirebaseMessaging() {
  const [fcmToken, setFcmToken] = useState<string | null>(null);
  const [message, setMessage] = useState<FirebaseMessage | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (typeof window === "undefined") return;
    let unsubscribeFunc: (() => void) | undefined;
    const initFirebase = async () => {
      const {
        messaging,
        getToken,
        onMessage
      } = await import("@/lib/firebase-config");
      if (!messaging) return;
      const requestPermissionAndGetToken = async () => {
        try {
          const permission = await Notification.requestPermission();
          if (permission === "granted") {
            const vapidKey = process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY;
            if (!vapidKey) {
              console.warn("VAPID key not configured");
              return;
            }
            const token = await getToken(messaging, {
              vapidKey
            });
            if (token) {
              setFcmToken(token);
            }
          } else {
            setError("Notification permission denied");
          }
        } catch (err) {
          console.error("Error getting FCM token:", err);
          setError(err instanceof Error ? err.message : "Failed to get FCM token");
        }
      };
      requestPermissionAndGetToken();
      unsubscribeFunc = onMessage(messaging, payload => {
        setMessage(payload as FirebaseMessage);
        if (payload.notification) {
          new Notification(payload.notification.title || "New Message", {
            body: payload.notification.body,
            icon: payload.notification.image || "/next.svg"
          });
        }
      });
    };
    initFirebase();
    return () => {
      if (unsubscribeFunc) {
        unsubscribeFunc();
      }
    };
  }, []);
  return {
    fcmToken,
    message,
    error
  };
}